import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './HubDashboard.css'; // You will need to create this for layout

const HubDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch only orders that are ready for Hub (Seller has "Delivered")
  const fetchHubOrders = async () => {
    try {
      const token = localStorage.getItem('user_token');
      // Backend should filter for status: 'SELLER_DELIVERED'
      const res = await axios.get('https://agro.atrmart.in/api/hub/orders', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOrders(res.data.data);
    } catch (err) {
      console.error("Hub fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const updateHubStatus = async (orderId, newStatus) => {
    try {
      await axios.post('https://agro.atrmart.in/api/hub/update-status', {
        order_id: orderId,
        status: newStatus
      });
      fetchHubOrders(); // Refresh list
    } catch (err) {
      alert("Failed to update status");
    }
  };

  useEffect(() => { fetchHubOrders(); }, []);

  return (
    <div className="hub-dashboard">
      <h1>Hub Operations Center</h1>
      <table className="hub-orders-table">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Seller Status</th>
            <th>Hub Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map(order => (
            <tr key={order.id}>
              <td>#{order.id}</td>
              <td>{order.user_name}</td>
              <td><span className="badge-delivered">Received from Seller</span></td>
              <td>
                <select onChange={(e) => updateHubStatus(order.id, e.target.value)} defaultValue={order.hub_status}>
                  <option value="PENDING">Pending (Checking)</option>
                  <option value="PROCESSING">Processing (Validated)</option>
                  <option value="SHIPPED">Shipped to Customer</option>
                  <option value="DELIVERED">Delivered to Customer</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HubDashboard;